import React from 'react';
import { Trans } from 'gatsby-plugin-react-i18next';
import { styled } from 'styled-components';
import Colors from '@components/shared/Colors';
import { TextVariant, Typography } from '@components/shared/design/Typography';
import { BREAKPOINT, DONATION_PERCENTAGE } from '@constants';

interface Props {
  currencySymbol: string;
  totalPrice: number;
  textKey?: string;
}

const DonationAmountBanner: React.FC<Props> = ({ currencySymbol, totalPrice, textKey = 'components.basket-donation' }) => {
  const donationAmount = Math.round(((totalPrice * DONATION_PERCENTAGE) / 100) * 100) / 100;
  const showBanner = process.env.SHOW_DONATION_BANNER === 'true';
  if (!showBanner) return null;

  return (
    <Container>
      <StyledTypography $variant={TextVariant.BodyRegularSM}>
        <Trans i18nKey={textKey} values={{ donation: `${currencySymbol}${donationAmount.toFixed(2)}` }} components={{ span: <span /> }} />
      </StyledTypography>
    </Container>
  );
};

export default DonationAmountBanner;

const Container = styled.div`
  width: 100%;
  padding: 8px 16px;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  background: ${Colors.babyBlue};

  @media (max-width: ${BREAKPOINT.tablet}px) {
    padding: 8px;
  }
`;

const StyledTypography = styled(Typography)`
  & span {
    font-weight: bold;
  }
`;
